import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=c4c1b77a&scoped=true"
import script from "./PopupNotification.vue?vue&type=script&lang=ts"
export * from "./PopupNotification.vue?vue&type=script&lang=ts"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&id=c4c1b77a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c1b77a",
  null
  
)

export default component.exports